/* eslint-disable react/destructuring-assignment */
import { GetServerSideProps, GetStaticProps, NextPage } from 'next';
import Head from 'next/head';

import { IMapRender } from '@/@types/events';
import Layout from '@/components/Layout';
import { makeApiClient, api } from '@/services/api';
import TemplateEventById, {
  TemplateEventByIdProps,
} from '@/templates/event-by-id';
import { makeCdnLink, stripHtml } from '@/utils';

const EventById: NextPage<TemplateEventByIdProps> = props => {
  return (
    <Layout
      seo={{
        image: makeCdnLink(props.rowEvent.imagemEvento) || null,
        title: props.rowEvent.nomeEvento,
        description: stripHtml(props.rowEvent.descEvento.slice(0, 160)),
      }}
    >
      <Head>
        <meta name="kdt:page" content="product" />
        {props.rowEvent.pixelMetaEvento !== '' && (
          <>
            <noscript>
              <img
                height="1"
                width="1"
                alt="pixel"
                style={{ display: 'none' }}
                src={`https://www.facebook.com/tr?id=${props.rowEvent.pixelMetaEvento}&ev=PageView&noscript=1`}
              />
            </noscript>
            <script
              id="meta-pixel"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', ${props.rowEvent.pixelMetaEvento});
          `,
              }}
            />
          </>
        )}
        {props.rowEvent.pixelTiktokEvento !== '' && (
          <>
            <script
              id="tiktok-pixel"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: `
                !function (w, d, t) {
                  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++
            )ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};

                  ttq.load('${props.rowEvent.pixelTiktokEvento}');
                  ttq.page();
                }(window, document, 'ttq');
          `,
              }}
            />
          </>
        )}
        {props.rowEvent.pixelGoogleEvento !== '' && (
          <>
            <script
              id="google-pixel"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: `
                gtag('config', '${props.rowEvent.pixelGoogleEvento}');
          `,
              }}
            />
          </>
        )}
      </Head>
      <TemplateEventById {...props} />
    </Layout>
  );
};

export const getStaticPaths = () => {
  return {
    paths: [],
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps<
  TemplateEventByIdProps,
  {
    id: string;
    slug: string;
  }
> = async context => {
  try {
    // const api = makeApiClient();
    const path = `/v1/web/events/${context.params.id}`;
    const response = await api.get(path);

    let mapRender: IMapRender | null = null;

    if (
      response.data.event.mapaSeatioEvento &&
      response.data.event.mapaSeatioEvento.length > 0
    ) {
      const { data: mapRenderResponse } = await api.get<IMapRender>(
        `https://mapa.boratickets.com.br/evento/${response.data.event.codEvento}/render`,
      );
      mapRender = mapRenderResponse;
    }

    return {
      props: {
        rowEvent: response.data.event,
        mapRender,
      },
      revalidate: 120,
    };
  } catch {
    return {
      notFound: true,
      revalidate: 10,
    };
  }
};

export default EventById;
